import React, { Fragment } from 'react'
import ImageGallery from './imageGallery'
import ProductPriceComponent from './ProductPriceComponent'

function ProductImageComponent({ product, showPrice = true }) {
    return (
        <Fragment>
            <ImageGallery product={product || null} images={product.images || []} />
            {showPrice &&
                <div className="float-price hidden-desk">
                    <ProductPriceComponent
                        product={product}
                    />
                </div>
            }
        </Fragment>
    )
}

export default ProductImageComponent